import * as React from 'react';
import _ from 'lodash';
import { Grid, Head } from 'semantic-grab-ui/src';
import './WidgetComponent.scss';
import { Campaign } from 'types/ts/campaigns';

const RandomizerShow = ({
  model,
  currentNode,
}: {
  model: Campaign;
  currentNode: string;
}) => {
  const branchPercentages = _.get(model.nodes[currentNode], 'data.branchPercentage', []);
  const actionsList = _.get(model.nodes[currentNode], 'data.actions', []);
  return (
    <div>
        {branchPercentages.map((percentage, index) =>
          (<Grid key={`${percentage}-${index}`}>
            <Grid.Column width={8}>
              Branch {index + 1} Percentage
            </Grid.Column>
            <Grid.Column width={4}>
              {percentage}%
            </Grid.Column>
          </Grid>)
        )}
        {actionsList.map((name, index) =>
          (<Grid key={`${name}-${index}`}>
            <Grid.Column width={8}>
              Action {index + 1}
            </Grid.Column>
            <Grid.Column width={4}>
              {name}
            </Grid.Column>
          </Grid>)
        )}
    </div>
  );
};

export default RandomizerShow;
